import type { ButtonProps } from '@/ui-components/atoms/Button/Button';

export const siteLinkToWeb2ButtonProps = (linkFields: SiteLinkFields): ButtonProps => {
    return {
        children: linkFields.link_text,
        href: linkFields.href || '',
        ariaLabel: linkFields.aria_label || linkFields.link_text,
        color: linkFields.ctaColor,
        linkTarget: linkFields.type === 'New Tab' ? '_blank' : '_self',
        size: linkFields.size?.toLowerCase() === 'small' ? 'small' : 'large',
        variant: linkFields.theme === 'text' ? 'tertiary' : linkFields.theme || 'primary',
        colorSet: linkFields.colorSet,
        tertiaryNoPadding: linkFields.theme === 'text' || linkFields.theme === 'tertiary',
        type: 'button',
        linkType: linkFields.link_type?.toLowerCase(),
        buttonType: linkFields.type,
        inheritParams: linkFields?.inheritParams,
    };
};
